// ./src/context/User/UserContext.js
import { createContext } from 'react'

const AlertContext = createContext(null)

export default AlertContext